<template>
  <v-card class="elevation-0 ma-8 px-2 py-6">
    <v-card-title>
        Alimentos
        <v-spacer></v-spacer>
        <v-text-field
            @keydown.enter="getDataFromApi()"
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
            class="mb-6 mx-4"
        ></v-text-field>
    </v-card-title>
    
    <v-data-table
        hide-default-footer
        :items="foods" 
        :headers="header"
        :footer-props="{'items-per-page-options':[15, 30, 50, totalFoods]}"
        :options.sync="options"
        :server-items-length="totalFoods"
        :loading="loading"
    >
    <template v-slot:[`item.actions`]="{ item }">
        <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
            </template>
            <v-list style="font-size:13px;">
                <v-list-item @click="edited_item = item, editDialog = true">
                    <v-icon small class="mr-2">
                        mdi-pencil
                    </v-icon>
                    Editar
                </v-list-item>
            </v-list>
        </v-menu>
    </template>
    </v-data-table>
    <v-snackbar :color="snackbar.color" v-model="snackbar.show">
        {{ snackbar.message }}
    </v-snackbar>
    <!-- Crear alimento -->
    <v-dialog v-model="createDialog" max-width="900px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn bottom color="#e12826" dark fab fixed right v-bind="attrs" v-on="on">
            <v-icon color="white">  mdi-plus </v-icon>
        </v-btn> 
      </template>
      <create @closeCreateDialog="closeCreateDialog"/>
    </v-dialog>
    <!-- editar alimento -->
    <v-dialog v-model="editDialog" max-width="900px">
      <edit v-bind:food="edited_item" @closeEditDialog="closeEditDialog"/>
    </v-dialog>
  </v-card>
</template>

<script>
import Create from './create.vue'
import Edit from './edit.vue'
import axios from "axios"
  export default {
    components:{
      'create': Create,
      'edit':Edit
    },
    data () {
      return {
        edited_item:{},
        editDialog:false,
        createDialog:false,
        editDialog: false,
        totalFoods: 0,
        foods: [],
        loading: true,
        options: {},
        activeSearch: false,
        search: '',
        header: [
            {text:'Alimento', value:'name'},
            {text:'Grupo Alimenticio', value:'food_group'},
            {text:'Unidad de Medida', value:'unit_of_measurement'},
            {value:'actions', sortable:false},
        ],
        snackbar: {
            show: false,
            message: null,
            color: null
        },
      }
    },
    watch: {
        options: {
            handler () {
                this.getDataFromApi()
            },
            deep: true,
        },
    },
    methods:{
        sendNotification(user_id){
            axios.post(process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/user/send_app_invite/'+user_id).then(resp=>{
                this.snackbar = {
                    color:'success',
                    show:true,
                    message:'Acceso enviado con éxito',
                }

            }).catch(error=>{
                this.snackbar = {
                    color:'error',
                    show:true,
                    message:'No se pudo enviar el acceso',
                }
            })
        },
        getDataFromApi () {
            this.loading = true
            this.apiCall().then(data => {
                this.foods = data.foods
                this.totalFoods = data.total
                this.loading = false
            })
        },
        apiCall () {
            return new Promise((resolve, reject) => {
                const { sortBy, sortDesc, page, itemsPerPage } = this.options
                var foods = []
                var total = 0
                var link = ''
                if(sortBy.length === 1){
                    if(sortDesc[0]){
                        link = link + "sort=-" + sortBy[0] + '&'
                    }else{
                        link = link + "sort=" + sortBy[0] + '&'
                    }
                }
                if(this.search!=''){
                    link = link + 'filter[name]=' + this.search + '&'
                }
                axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/food?" + link + "page=" + page + "&itemsPerPage=" + itemsPerPage).then(response => {
                    foods = this.mapFoods(response.data)
                    total = foods.length
                    resolve({
                        foods,
                        total,
                    })
                })
            })
        },
        mapFoods(items){
            return items.filter(objeto => !("header" in objeto) && !("divider" in objeto));
        },
        closeCreateDialog: function(params){
            this.getDataFromApi()
            this.createDialog = params
        },
        closeEditDialog: function(params){
            this.getDataFromApi()
            this.editDialog = params
        }
    }
}
</script>

<style scoped>
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>